import EmbeddedPage from './EmbeddedPage';

export default EmbeddedPage;
